import React from 'react';
import styled from '@emotion/styled';

import { Intensity } from '~/src/components';
import { breakpoints } from '~/src/styles';

const LevelContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  grid-column: 2/3;
  ${breakpoints.minDesktop} {
    grid-column: unset;
  }
`;

interface Props {
  intensity?: { id: string; name: string }[];
}

export const Level: React.FC<Props> = ({ intensity }) => {
  return (
    <LevelContainer>
      {intensity?.[0] && <Intensity id={intensity[0].id} name={intensity[0].name} />}
    </LevelContainer>
  );
};
